import { render, staticRenderFns } from "./UtenteCallCenter.vue?vue&type=template&id=3572973c&"
import script from "./UtenteCallCenter.vue?vue&type=script&lang=ts&"
export * from "./UtenteCallCenter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports